import { supabase } from './supabaseClient';
import { getCurrentUser, resolveBillId as resolveBillIdFromSaved } from './savedBills';

export async function fetchFavoriteStatusesForBillIds(billIds) {
  const user = await getCurrentUser();
  if (!user || !Array.isArray(billIds) || billIds.length === 0) return new Set();
  const { data, error } = await supabase
    .from('favorited_bills')
    .select('bill_id')
    .eq('user_id', user.id)
    .in('bill_id', billIds);
  if (error) {
    // eslint-disable-next-line no-console
    console.warn('fetchFavoriteStatusesForBillIds error:', error.message);
    return new Set();
  }
  return new Set((data || []).map((r) => r.bill_id));
}

export async function toggleFavoriteBill(billId, shouldFavorite) {
  const user = await getCurrentUser();
  if (!user) throw new Error('Not authenticated');
  if (shouldFavorite) {
    const { error } = await supabase.from('favorited_bills').upsert({ user_id: user.id, bill_id: billId });
    if (error) throw error;
    return true;
  } else {
    const { error } = await supabase.from('favorited_bills').delete().eq('user_id', user.id).eq('bill_id', billId);
    if (error) throw error;
    return false;
  }
}

export async function fetchFavoritedBills() {
  const user = await getCurrentUser();
  if (!user) return [];
  const { data, error } = await supabase
    .from('favorited_bills')
    .select('bill_id, bills(*)')
    .eq('user_id', user.id)
    .order('created_at', { ascending: false });
  if (error) {
    // eslint-disable-next-line no-console
    console.warn('fetchFavoritedBills error:', error.message);
    return [];
  }
  return data || [];
}

export async function resolveBillId(bill) {
  // Reuse implementation from savedBills for consistency
  return resolveBillIdFromSaved(bill);
}


